import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import styled, { css } from 'styled-components';
import { ListItem } from '../ListItem';
import { Box } from '../../../../../layout/Box';
import { DROPDOWN_PADDING } from '../../../';

var List =
/** @class */
function (_super) {
  __extends(List, _super);

  function List() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onSelectItem = function (item, index) {
      return function (e) {
        if (_this.props.onSelectItem) {
          _this.props.onSelectItem(item, index, e);
        }
      };
    };

    _this.renderListItems = function () {
      return _this.props.items.map(function (item, i) {
        return React.createElement(StyledListItem, {
          disabled: item.disabled,
          isHighlighted: item.isHighlighted,
          isSelected: item.isSelected || _this.props.selectedIndex === i,
          key: item.label
        }, React.createElement(ListItem, __assign({
          "aria-role": item.url ? 'link' : 'button',
          itemRenderer: _this.props.itemRenderer,
          onSelect: _this.onSelectItem(item, i)
        }, item)));
      });
    };

    return _this;
  }

  List.prototype.render = function () {
    var _a = this.props,
        emptyState = _a.emptyState,
        items = _a.items;
    return React.createElement(StyledList, {
      hideLines: this.props.hideLines
    }, emptyState && items.length === 0 ? React.createElement(Box, {
      p: 2
    }, emptyState) : this.renderListItems());
  };

  return List;
}(React.Component);

export { List };
/**
 * TODO: Import UnorderedList and OrderedList into studio and use here.
 */

var StyledList = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    list-style: none;\n    margin-top: ", ";\n    padding: 0;\n    text-align: left;\n\n    ", ";\n"], ["\n    list-style: none;\n    margin-top: ", ";\n    padding: 0;\n    text-align: left;\n\n    ", ";\n"])), function (props) {
  return props.theme.units.getValue(DROPDOWN_PADDING / 2);
}, function (props) {
  return !props.hideLines && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            li:not(:last-child) {\n                border-bottom: ", " solid\n                    ", ";\n            }\n        "], ["\n            li:not(:last-child) {\n                border-bottom: ", " solid\n                    ", ";\n            }\n        "])), props.theme.strokeWidths.thick, props.theme.colors.gray5);
});
var StyledListItem = styled.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"], ["\n    background-color: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (props) {
  return props.isHighlighted ? props.theme.colors.gray5 : 'none';
}, function (props) {
  return !props.disabled && !props.isSelected && props.theme.colors.gray5;
});
var templateObject_1, templateObject_2, templateObject_3;